export enum AntragStatus {
  Undefiniert = 0,
  Initial = 100,
  Unerledigt = 200,
  Vollstaendig = 300, // erfolgreich(gruen)
  Einreichen = 500,
  Eingereicht = 600, // erfolgreich(gruen)
  Uebergeben = 700,
  InBearbeitung = 800,
  Abgelehnt = 900,
  Beschieden = 950,
}
